import { useCallback } from "react";

import { AuthWrapper } from "@/lib/aws-amplify";

import { DevelopmentTools } from "@/hooks/use-development-tools";

import { useAuth } from "@/providers";

export const useSignOutSilently = () => {
	const { signOutCallback } = useAuth();
	const { consoleErrorOnlyDevMode } = DevelopmentTools();

	const signOutSilently = useCallback(
		() =>
			AuthWrapper.authSignOut()
				.then(() => {
					signOutCallback();
				})
				.catch((err) => {
					consoleErrorOnlyDevMode(err);
				}),
		[consoleErrorOnlyDevMode, signOutCallback],
	);

	return {
		signOutSilently,
	};
};
